/**
 * Accordion
 */

(function ($) {
    var accordion__toggle = '.js-accordion__toggle';
    var accordion__content = '.js-accordion__content';
    var accordion__hiddenClass = 'is-hidden';
    var accordion__activeClass = 'is-active';

    $(accordion__content).hide();

    $(document).on('click', '.js-accordion__toggle', function () {

        var $this = $(this);

        $this.next(accordion__content).slideToggle("fast").siblings(accordion__content + ":visible").slideUp("fast");
        $this.toggleClass(accordion__activeClass);
        $this.siblings(accordion__toggle).removeClass(accordion__activeClass);

    });

})(jQuery);
